import "../../Styles/Landing/SponsorL.css";
import Sponsor from "../../Assets/Sponsor.png";
import { NavLink } from "react-router-dom";

const SponsorL = () => {
  return (
    <section className="sponsorL">
      <img src={Sponsor} alt="Sponsor a student" />
      <div>
        <hr />
        <h1>Sponsor a student</h1>
        <p>
          Your support can transform the life of a female, giving her the opportunity to gain Islamic knowledge and
          build a future grounded in faith.
          <br />
          <br />
          Allah (SWT) says in the Qur'an: "And whatever you spend in good, it will be fully repaid to you, and you will
          not be wronged." (Surah Al-Baqarah 2:272)
        </p>
        <NavLink to="/sponsor">Continue</NavLink>
      </div>
    </section>
  );
};

export default SponsorL;
